// extracted by mini-css-extract-plugin
export default {"headerCell":"TableResults_headerCell__4n8+r","cell":"TableResults_cell__aczbT"};